module.exports = __webpack_public_path__ + "static/media/YF25_0.a197c776.jpg";